import { Box } from '@achieve/ascend'
import { MediaImageStandard, Typography } from 'components/Contentful'
import { get as _get } from 'lodash-es'
import { bytesToSize } from 'utils/conversions'
import { rewriteAssetUrl } from 'utils/conversions/urls'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'

function CardArticleFileDownload({ content }) {
  const title = _get(content, 'fields.title', '')
  const downloadText = _get(content, 'fields.ctaField', '') || 'Download'
  const downloadDescription = _get(content, 'fields.description', '')
  const downloadFile = rewriteAssetUrl(_get(content, 'fields.downloadFile.fields.file.url', ''))
  const downloadFileSize = _get(content, 'fields.downloadFile.fields.file.details.size', 0)
  const downloadSize = `${bytesToSize(downloadFileSize)}`
  const image = _get(content, 'fields.image', '')

  return (
    <Box
    sx={{
      border: ['none', null, '1px solid #e0e0e0'],
      borderRadius: [0, null, '20px'],
    }}
    className="max-w-[310px] lg:max-w-[730px] flex flex-col lg:flex-row bg-white border-0 lg:border lg:border-[#e0e0e0] rounded-none lg:rounded-[20px] p-0 lg:p-10"
  >
    <Box className="relative w-[310px] h-[220px] lg:max-h-[220px] flex-shrink-0">
      <MediaImageStandard
        className="rounded-[12px]"
        content={image}
        width={310}
        layout="fill"
        objectFit="contain"
        height={220}
      />
    </Box>
    <Box className="flex flex-col justify-center ml-0 lg:ml-[30px] max-w-[310px]">
      <div className="mt-5 lg:mt-0">
        <AchieveLink
          href={downloadFile}
          target="blank"
          download
          className="hover:underline hover:decoration-[#1D252F]"
        >
          <Typography
            className="text-[#1D252F] font-bold text-lg"
            content={title}
            variant="bodyLg"
            component="h3"
          />
        </AchieveLink>
      </div>

      {downloadDescription && (
        <Typography
          className="pt-3 text-[#1D252F] block max-w-[400px] line-clamp-2"
          content={downloadDescription}
          variant="bodySm"
        />
      )}

      <Typography className="py-3 text-[#1D252F]" content={downloadSize} variant="bodySm" />

      <Box>
        <AchieveLink
          href={downloadFile}
          target="blank"
          download
          className="hover:underline"
        >
          <Typography content={downloadText} variant="bodySm" fontWeight="bold" />
        </AchieveLink>
      </Box>
    </Box>
  </Box>
  )
}

export { CardArticleFileDownload }
